import React from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../../../components/Common/UI/DataTable';
import Icons from '../../../../components/Common/Icons/Icons';
import PageSubHeader from '../../Common/PageSubHeader';
import { TabProps, Tabs, TabsContent, TabsList, TabsTrigger } from '../../../../components/Common/UI/Tabs';
import { messageManagerData } from '../Dashboard/data/messageManager';
import { messageManagerCol } from './columns';
import { Button } from '../../../../components/Common/UI/Button';
import DatePickerWithRange from '../../../../components/Common/UI/DateRange';

function MessageManager() {
  const navigate = useNavigate();
  const data = [...messageManagerData, ...messageManagerData];

  const tabs: TabProps[] = [
    {
      value: 'all',
      label: 'All',
      content: <DataTable columns={messageManagerCol} data={data} initialState={{ pagination: { pageSize: 10 } }} />,
    },
    {
      value: 'scheduled',
      label: 'Scheduled',
      content: (
        <DataTable
          columns={messageManagerCol}
          data={data.filter(el => el.status === 'scheduled')}
          initialState={{ pagination: { pageSize: 10 } }}
        />
      ),
    },
    {
      value: 'draft',
      label: 'Draft',
      content: (
        <DataTable
          columns={messageManagerCol}
          data={data.filter(el => el.status === 'draft')}
          initialState={{ pagination: { pageSize: 10 } }}
        />
      ),
    },
    {
      value: 'completed',
      label: 'Completed',
      content: (
        <DataTable
          columns={messageManagerCol}
          data={data.filter(el => el.status === 'completed')}
          initialState={{ pagination: { pageSize: 10 } }}
        />
      ),
    },
  ];

  return (
    <div>
      <PageSubHeader
        leftContent={
          <div className="flex items-center gap-2">
            <Icons.MessageFilled className="size-6" />
            <span>Message Manager</span>
          </div>
        }
        breadcrumbs={[
          { path: '/infoTrac/', label: <Icons.HomeOutlined />, disableBg: true },
          { path: '/infoTrac', label: 'InfoTRAC' },
          { path: '/infoTrac/message-manager', label: 'Message Manager' },
        ]}
      />

      <Tabs defaultValue="all" className="">
        <div className="page-heading px-4 py-2 flex items-center justify-between bg-slate-100">
          <TabsList>
            {tabs.map(({ value, label }) => (
              <TabsTrigger key={`${value}-trigger`} value={value}>
                {label}
              </TabsTrigger>
            ))}
          </TabsList>

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <DatePickerWithRange />
            </div>
            <Button onClick={() => navigate('/infoTrac/message-manager/builder')}>Create New Campaign</Button>
          </div>
        </div>

        {tabs.map(({ value, content }) => (
          <TabsContent key={value} value={value}>
            {content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}

export default MessageManager;
